<template>
    <Tooltip
        v-if="isDisplayed && block.tooltip?.value"
        :tip="block.tooltip?.value"
        :placement="block.tooltip?.placement"
        class="tooltip-decorator"
    >
        <slot v-bind="$attrs" />
    </Tooltip>
    <slot
        v-else
        v-bind="$attrs"
    />
</template>

<script setup lang="ts">
import Tooltip from 'widget-components/atoms/Tooltip/Tooltip.vue'
import type { BlockProps } from '../types'
import useConditions from 'widget-components/composables/conditions/useConditions'
import { computed, toRef } from 'vue'

const props = defineProps<BlockProps>()
const blockFlex = computed(() => (props.block.type === 'CONTAINER' ? props.block.flexMultiplier : null) ?? 1)

const blockId = computed(() => props.block.id)

const { isDisplayed } = useConditions(
    blockId,
    toRef(props, 'parentIndex'),
    toRef(props, 'parentId'),
)
</script>

<style lang="sass" scoped>
.tooltip-decorator
    flex: v-bind(blockFlex)
</style>
